export const MEETING_ALERT_TYPE = 'meeting_filter_alert';
export const MEETING_ALERTS_TAB_KEY = {
  teamMate: 'teamMate',
  my: 'my',
  standard: 'standard'
};
export const INITIAL_FILTERS = {
  more: {
    includeInternalMeetings: true,
    showInternalOnly: false,
    sharedMeetingsOnly: false,
    showUnrecordedMeetings: true
  }
};

export const slackCustomizationMapping = {
  crm_data: { title: 'Deal Information', infoTooltip: '' },
  transcript_data: { title: 'Transcript', infoTooltip: '' },
  all_key_takeaways: { title: 'Key Takeaways', infoTooltip: '' },
  deal_risk_analysis: {
    title: 'Deal Risk Analysis',
    infoTooltip:
      'Available only for meetings where the attributed user has the Revenue Intelligence Addon.'
  },
  forecast_risk_analysis: {
    title: 'Forecast Risk Analysis',
    infoTooltip:
      'Available only for meetings where the attributed user has the Revenue Intelligence Addon.'
  },
  churn_risk_analysis: {
    title: 'Churn Risk Analysis',
    infoTooltip:
      'Available only for meetings where the attributed user has the Revenue Intelligence Addon.'
  },
  expansion_opportunity_analysis: {
    title: 'Expansion Opportunity Analysis',
    infoTooltip:
      'Available only for meetings where the attributed user has the Revenue Intelligence Addon.'
  },
  feature_request_analysis: {
    title: 'Feature Request Analysis',
    infoTooltip:
      'Available only for meetings where the attributed user has the Conversation Intelligence Addon.'
  },
  issues_reported_analysis: {
    title: 'Issues Reported Analysis',
    infoTooltip:
      'Available only for meetings where the attributed user has the Conversation Intelligence Addon.'
  },
  coaching_recommendations: {
    title: 'Coaching Recommendations',
    infoTooltip:
      'Available only for meetings where the attributed user has the Conversation Intelligence Addon.'
  },
  full_notes: {
    title: 'Meeting Notes',
    infoTooltip: 'Full meeting notes will be added to the alert message thread.'
  },
  momentum_risk_analysis: {
    title: 'Momentum Risk Analysis',
    infoTooltip:
      'Available only for internal meetings where the attributed user has the Conversation Intelligence Addon.'
  },
  project_risk_analysis: {
    title: 'Project Risk Analysis',
    infoTooltip:
      'Available only for internal meetings where the attributed user has the Conversation Intelligence Addon.'
  },
  strategic_signal_analysis: {
    title: 'Strategic Signal Analysis',
    infoTooltip:
      'Available only for internal meetings where the attributed user has the Conversation Intelligence Addon.'
  },
  feedback_analysis: {
    title: 'Feedback Analysis',
    infoTooltip:
      'Available only for internal meetings where the attributed user has the Conversation Intelligence Addon.'
  }
};

export const microsoftTeamsCustomizationMapping = {
  crm_data: { title: 'Deal Information', infoTooltip: '' },
  all_key_takeaways: { title: 'Key Takeaways', infoTooltip: '' },
  deal_risk_analysis: {
    title: 'Deal Risk Analysis',
    infoTooltip:
      'Available only for meetings where the attributed user has the Revenue Intelligence Addon.'
  },
  forecast_risk_analysis: {
    title: 'Forecast Risk Analysis',
    infoTooltip:
      'Available only for meetings where the attributed user has the Revenue Intelligence Addon.'
  },
  churn_risk_analysis: {
    title: 'Churn Risk Analysis',
    infoTooltip:
      'Available only for meetings where the attributed user has the Revenue Intelligence Addon.'
  },
  expansion_opportunity_analysis: {
    title: 'Expansion Opportunity Analysis',
    infoTooltip:
      'Available only for meetings where the attributed user has the Revenue Intelligence Addon.'
  },
  feature_request_analysis: {
    title: 'Feature Request Analysis',
    infoTooltip:
      'Available only for meetings where the attributed user has the Conversation Intelligence Addon.'
  },
  issues_reported_analysis: {
    title: 'Issues Reported Analysis',
    infoTooltip:
      'Available only for meetings where the attributed user has the Conversation Intelligence Addon.'
  },
  momentum_risk_analysis: {
    title: 'Momentum Risk Analysis',
    infoTooltip:
      'Available only for internal meetings where the attributed user has the Conversation Intelligence Addon.'
  },
  project_risk_analysis: {
    title: 'Project Risk Analysis',
    infoTooltip:
      'Available only for internal meetings where the attributed user has the Conversation Intelligence Addon.'
  },
  strategic_signal_analysis: {
    title: 'Strategic Signal Analysis',
    infoTooltip:
      'Available only for internal meetings where the attributed user has the Conversation Intelligence Addon.'
  },
  feedback_analysis: {
    title: 'Feedback Analysis',
    infoTooltip:
      'Available only for internal meetings where the attributed user has the Conversation Intelligence Addon.'
  },
  coaching_recommendations: {
    title: 'Coaching Recommendations',
    infoTooltip:
      'Available only for meetings where the attributed user has the Conversation Intelligence Addon.'
  }
};
